export { Textarea } from "@mantine/core";
export type { TextareaProps } from "@mantine/core";
export { textareaOverrides } from "./Textarea.config";
